import { render, staticRenderFns } from "./OrgDeleteModal.vue?vue&type=template&id=ff4c9352"
import script from "./OrgDeleteModal.vue?vue&type=script&lang=js"
export * from "./OrgDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports